import { z } from 'zod';
import { messages } from '@/config/messages';
import { fileSchema } from './common-rules';
import { Order } from '@/types';
import { Label } from 'recharts';

// form zod validation schema
export const OrderFormSchema = z.object(
  {
    id: z.string().optional(),
    orderId: z.string().optional(),
    quantity: z.number().int().positive({ message: messages.quantityIsRequired }),
    totalPrice: z.number().int().optional(),
    status: z.string().optional(),
    shippingAddress: z.string().nonempty({ message: messages.shippingAddressIsRequired }),
    paymentMethod: z.string().optional(),
    trackingNumber: z.string().optional(),
    deliveryDate: z.date().optional(),
    productId: z.string().optional(),
    product: z.object({
      name: z.string().nonempty({ message: messages.productNameIsRequired }),
      description: z.string().nonempty({ message: messages.descriptionIsRequired }),
      price: z.number().int().optional(),
      categoryId: z.object({ value: z.string().nonempty({ message: messages.productCategoryIsRequired }) }).optional(),
      // category: z.string().nonempty({ message: messages.productCategoryIsRequired }),
      supplier: z.string().optional(),
      weight: z.number().int().optional(),  
      imagePath: z.string().optional(),
    }),
    clientId: z.string().optional(),
    createdDate: z.date().optional(),
  },
);

// generate form types from zod validation schema
export type CreateOrderInput = z.infer<typeof OrderFormSchema>;
